import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";
import { Seo } from "../components/Seo";
import { PageHero } from "../components/PageHero";
import { Stagger, itemVariant, Reveal } from "../components/Reveal";
import { APPLICATIONS, IMAGES } from "../data/content";

export default function Applications() {
  const { t, lang } = useLang();
  return (
    <>
      <Seo title="Anwendungen für TPU – Schläuche, Folien, Kabel, Profile | PlastoNord"
        description="TPU Anwendungen: Schläuche & Rohre, Folien, Kabelummantelung, Profile, Spritzgussbauteile, Dichtungen und mehr. Das richtige Material für Ihre Anwendung."
        path="/anwendungen" />
      <PageHero overline={t("nav.applications")}
        title={lang === "de" ? "Das richtige Material für Ihre Anwendung" : "The right material for your application"}
        subtitle={lang === "de" ? "TPU ist außergewöhnlich vielseitig – von flexiblen Schläuchen bis zu belasteten technischen Bauteilen." : "TPU is exceptionally versatile – from flexible tubing to loaded technical components."} />
      <section className="py-24">
        <div className="pn-container">
          <Stagger className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {APPLICATIONS.map((a, i) => (
              <motion.div key={i} variants={itemVariant} className="pn-card p-6">
                <span className="font-mono text-xs text-[#E2611C]">0{i + 1}</span>
                <h3 className="mt-2 font-head text-lg font-semibold text-[#16181D]">{lang === "de" ? a.de : a.en}</h3>
              </motion.div>
            ))}
          </Stagger>
          <Reveal delay={0.1}>
            <div className="mt-14 grid items-center gap-10 rounded-2xl border border-[#e4e9f0] p-8 lg:grid-cols-2">
              <div>
                <h2 className="font-head text-2xl font-medium text-[#16181D]">{lang === "de" ? "TPU für Extrusion vs. Spritzguss" : "TPU for extrusion vs. injection molding"}</h2>
                <p className="mt-4 leading-relaxed text-[#4a4d52]">{lang === "de" ? "Für die Extrusion (Schläuche, Profile, Folien, Kabel) werden Typen mit höherer Schmelzefestigkeit eingesetzt. Im Spritzguss kommen Typen mit höherem MFI für eine gute Formfüllung technischer Bauteile zum Einsatz." : "Extrusion (tubing, profiles, films, cables) uses grades with higher melt strength. Injection molding uses grades with higher MFI for good mold filling of technical parts."}</p>
                <Link to="/tpu" className="btn-primary mt-6 !px-5 !py-2 text-sm">{t("cta.explore")} <ArrowRight size={15} /></Link>
              </div>
              <img src={IMAGES.macro} alt="TPU Granulat für Extrusion und Spritzguss" className="rounded-xl border border-[#e4e9f0]" loading="lazy" />
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
